import { ThunkAction } from "redux-thunk";
import { apiLoad, Dispatch, pushMessage, apiAuthenticationRequest } from "../../shared/timeclock/actions";
import { CANCEL, SELF_REGISTRATION_BEGIN, STAMP_FINGERPRINT_READ, SCREENSAVER_POLL, SCREENSAVER_RESET, BACK_STAMP, API_ERROR } from "../../shared/timeclock/actions";
import { Action } from "../../shared/timeclock/models/redux";
import { api } from "../../shared/timeclock/services";
import { RootState, Session } from "../reducers";
import { Errors as ErrorMessages, SelfRegistration } from "../messages";
import { SelfRegistrationRequest } from "../../shared/timeclock/services/api";

export function stampFingerprintRead(): Action {
    return {
        type: STAMP_FINGERPRINT_READ
    };
}


export function selfRegistrationBegin(): Action {
    return {
        type: SELF_REGISTRATION_BEGIN
    };
}

function apiError(category, error) {
    const systemMessage = error.jsonError
        ? { id: `${category}.${error.jsonError.type}`, values: error.jsonError.values }
        : ErrorMessages.Network;

    return {
        systemMessage,
        type: API_ERROR
    };
}

export function selfRegistrationComplete(request: SelfRegistrationRequest): ThunkAction<void, RootState, never> {
    return (dispatch: Dispatch) => {
        dispatch(apiLoad());
        api
            .selfRegister(request)
            .then((response) => {
                const systemMessage = response.existingPerson
                    ? SelfRegistration.CompleteReactivated
                    : SelfRegistration.CompleteNoConfirm;
                dispatch(pushMessage({ systemMessage }));
                dispatch(apiAuthenticationRequest({ code: response.emplNo }));
            })
            .catch((error) => {
                dispatch(apiError("SelfRegistration.Errors", error));
                dispatch({ type: CANCEL });
            });
    };
}

export function back(): ThunkAction<void, RootState, never> {
    return (dispatch: Dispatch, getState) => {
        const session: Session = getState().session;
        const person = session.stampPerson;

        if (session.loginTimerId) {
            clearTimeout(session.loginTimerId);
        }
        dispatch({ type: BACK_STAMP, person });
    };
}

export function screensaverPoll(): Action {
    return {
        type: SCREENSAVER_POLL
    };
}

export function screensaverReset(): Action {
    return {
        type: SCREENSAVER_RESET
    };
}
